import { arrayMove } from '@dnd-kit/sortable'


export const sortItems = (items, event) => {
  const { active, over } = event

  if (!over || active.id === over.id) {
    return null
  }

  const oldIndex = items.findIndex(({ id }) => id === active.id)
  const newIndex = items.findIndex(({ id }) => id === over.id)

  return arrayMove(items, oldIndex, newIndex)
}
